module.exports = __webpack_public_path__ + "img/1tnp.4c066d6e.png";